import {
  req,
  len,
  withParams
} from 'vuelidate/lib/validators/common';

export default (length) => withParams(
    {type: 'exactLength', length: length},
    (value) => {
      return !req(value) || len(value) === length;
    }
);